import { Component, inject } from '@angular/core';

import { BreadcrumbListComponent } from '@r1-compass-library/components/breadcrumb-list/breadcrumb-list.component';
import { MatButtonModule } from '@angular/material/button';
import { FileTableComponent } from '@r1-compass-library/components/file-table/file-table.component';
import { PlaysListStore } from './plays-list.store';
import { Play, PlayGeneratorType } from '@r1-compass-library/models';
import { MatMenuModule } from '@angular/material/menu';
import { AppConstants } from '../../app.constants';
import { PlayFolderService, PlayService } from '@r1-compass-library/services';
import { AssetListComponent } from '../../asset-list.component';

@Component({
    selector: 'r1-compass-app-plays-list',
    imports: [BreadcrumbListComponent, FileTableComponent, MatButtonModule, MatMenuModule],
    templateUrl: './plays-list.component.html',
    styleUrl: './plays-list.component.scss',
})
export class PlaysListComponent extends AssetListComponent<Play, PlayService, PlayFolderService, PlaysListStore> {
    protected playsListStore: PlaysListStore;

    override EDIT_ASSET_PATH: string = AppConstants.PlayDefinitionComponent.path;
    override BASE_PATH = '/plays';
    override columns = AppConstants.folderNavColumnsForPlays;

    constructor() {
        super(inject(PlaysListStore), inject(PlayService), inject(PlayFolderService));
        this.playsListStore = inject(PlaysListStore);
    }

    override onCreateAsset(): void {
        // use onCreatePlay instead.
    }

    onCreatePlay(type: PlayGeneratorType) {
        this.router.navigate(['new/definition'], {
            relativeTo: this.route,
            queryParams: { generatorType: type, folderId: this.folderId },
        });
    }
}
